import { makeAutoObservable, runInAction } from 'mobx';
import { CinemaProvider } from '../../data';
import { FiltersType } from '../../data/models/cinema';
import moment from 'moment';

class ContentState {
  _filters: FiltersType = {
    category: [],
    distributor: [],
    genre: [],
    year: [],
    country: [],
    sort: [],
  };

  _historyModify = 0;
  _favoritesModify = 0;
  _lastSearch = 0;

  _expanded = false;
  _tabBarHeight = 0;

  constructor() {
    makeAutoObservable(this);
  }

  async getFilters() {
    if (this._filters.category.length > 0) return;

    const res = await CinemaProvider.filters();
    runInAction(() => {
      this._filters = res;
    });
  }

  get historyModify() {
    return this._historyModify;
  }

  updateHistory() {
    this._historyModify = moment().unix();
  }

  get favoritesModify() {
    return this._favoritesModify;
  }

  updateFavorites() {
    this._favoritesModify = moment().unix();
  }

  get lastSearch() {
    return this._lastSearch;
  }

  updateLastSearch() {
    this._lastSearch = moment().unix();
  }

  get expanded() {
    return this._expanded;
  }
  set expanded(value: boolean) {
    this._expanded = value;
  }

  get tabBarHeight() {
    return this._tabBarHeight;
  }
  set tabBarHeight(value: number) {
    this._tabBarHeight = value;
  }
}

export default new ContentState();
